"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var helpers_1 = require("../../helpers");
var InputBox_1 = require("../helpers/InputBox");
var InputControl_1 = require("../helpers/InputControl");
var useControlState_1 = require("../helpers/useControlState");
var types_1 = require("../types");
var svg_1 = require("./svg");
var public_1 = require("../../common/public");
exports.MIN_WIDTH_PASSWORD_INPUT = '57px';
var StyledInputBox = styled_components_1.default(InputBox_1.InputBox)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    min-width: ", ";\n"], ["\n    min-width: ", ";\n"])), exports.MIN_WIDTH_PASSWORD_INPUT);
var StyledInputControl = styled_components_1.default(InputControl_1.InputControl)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding-top: calc(", " - ", ");\n    padding-bottom: calc(", " - ", ");\n"], ["\n    padding-top: calc(", " - ", ");\n    padding-bottom: calc(", " - ", ");\n"])), helpers_1.SPACING_S, helpers_1.BASE_BORDER_WIDTH, helpers_1.SPACING_S, helpers_1.BASE_BORDER_WIDTH);
exports.PasswordInput = helpers_1.createUIElement('PasswordInput', function (_a, ref) {
    var className = _a.className, _b = _a.value, value = _b === void 0 ? '' : _b, onBlur = _a.onBlur, onFocus = _a.onFocus, onChange = _a.onChange, _c = _a.size, size = _c === void 0 ? public_1.CONTROL_SIZE.m : _c, placeholder = _a.placeholder, disabled = _a.disabled, _d = _a.error, error = _d === void 0 ? false : _d, readOnly = _a.readOnly, _e = _a.hasEye, hasEye = _e === void 0 ? true : _e, onMouseDown = _a.onMouseDown, controlRef = _a.controlRef, fullWidth = _a.fullWidth, _f = _a.autocomplete, autocomplete = _f === void 0 ? 'off' : _f, _g = _a.hasEnterKeyStopPropagation, hasEnterKeyStopPropagation = _g === void 0 ? false : _g, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "value", "onBlur", "onFocus", "onChange", "size", "placeholder", "disabled", "error", "readOnly", "hasEye", "onMouseDown", "controlRef", "fullWidth", "autocomplete", "hasEnterKeyStopPropagation", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    var _h = useControlState_1.useControlState({ rootRef: ref }), focused = _h.focused, input = _h.input;
    var _j = helpers_1.useStateValue(value, [value]), setValue = _j.setValue, getValue = _j.getValue;
    var _k = react_1.useState(false), isShowPassword = _k[0], setIsShowPassword = _k[1];
    var currentValue = getValue();
    var isFocused = focused || isShowPassword;
    var showPassword = function () {
        setIsShowPassword(true);
    };
    var hidePassword = function () {
        setIsShowPassword(false);
    };
    var handleMouseDown = function () {
        showPassword();
        onMouseDown === null || onMouseDown === void 0 ? void 0 : onMouseDown();
    };
    var handlePreventCopy = function (e) {
        e.stopPropagation();
        e.preventDefault();
    };
    var handleChange = function (e) {
        setValue(e.target.value);
        onChange === null || onChange === void 0 ? void 0 : onChange(getValue());
    };
    var handleFocus = function (e) {
        input.onFocus(e);
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
    };
    var handleBlur = function (e) {
        input.onBlur(e);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
    };
    var handleKeyDown = function (e) {
        if (isShowPassword) {
            e.stopPropagation();
            e.preventDefault();
        }
        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
    };
    return (react_1.default.createElement(StyledInputBox, __assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'password-input-wrapper', className: "vm-PasswordInput " + className, "data-text-input": true, tabIndex: -1, isDisabled: disabled, isFocused: isFocused, size: fullWidth ? public_1.CONTROL_SIZE.full : size, hasError: error, hasSpacing: false, actions: hasEye && currentValue.length > 0
            ? [
                {
                    testId: 'password-input-view-password-trigger',
                    icon: react_1.default.createElement(svg_1.ShowPasswordIcon, { isDisabled: disabled, isError: error }),
                    active: isShowPassword,
                    onMouseDown: handleMouseDown,
                    onMouseUp: hidePassword,
                    onMouseLeave: hidePassword
                }
            ]
            : undefined, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: handleKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
        react_1.default.createElement(StyledInputControl, { ref: controlRef, "data-selector-id": "password-input-text-input", "data-error-state": error ? true : undefined, hasSpacing: true, value: currentValue, hasEnterKeyStopPropagation: hasEnterKeyStopPropagation, placeholder: placeholder, disabled: disabled, readOnly: readOnly, onBlur: handleBlur, onFocus: handleFocus, onChange: handleChange, onCopy: handlePreventCopy, onCut: handlePreventCopy, type: isShowPassword ? types_1.INPUT_TYPE.text : types_1.INPUT_TYPE.password, autocomplete: autocomplete })));
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=PasswordInput.js.map